import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Button } from 'antd';
import logo from '../../../images/logo.png';
import { fromValidate, history } from '../../../helpers'

class Signup extends Component {

	constructor(props) {
		super(props);
		this.state = {
			formError: {},
			formSubmit: false,
			user: {},
			userNumber: '****7890',
			isSuccess: true,
		}
	}

	handleChange = (e) => {
		const user = Object.assign({}, this.state.user)
		const name = e.target.name;
		const value = e.target.value;
		user[name] = value;
		this.setState({ user });

		if (this.state.formSubmit) {
			this.setState({ formError: {} })
			const formValidation = fromValidate(this.fromNode);
			if (!formValidation.valid) {
				this.setState({ formError: formValidation.invalidationEle })
			}
		}
	}

	handleSubmit = () => {
		history.push('/application')
	}
	goToSignUpCategory=()=>{
		history.push('/signUpCategory')
	}

	render() {
		const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
		return (
			<div className='login-container'>
				
				<div className='login-box'>
					<div className='logo-box-logo reset-logo-right'>
						<img className='login-logo-image' src={logo}></img>
					</div>
					<div className='txt-login'>REGISTRACTION</div>
					{/* <div className='txt-desc'>This extra step is to verify that it's really you trying to log in</div>
					{isSuccess && <div className='txt-success-msg'>A text message with a 6 digit verification code has been sent to phone number ending {userNumber}</div>} */}
					<form ref={node => this.fromNode = node} noValidate autoComplete="off" onSubmit={(e) => { this.handleSubmit(e) }}>
						<div>
							<div>
								<input
									required
									id="code"
									label="Code"
									type="text"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="First Name"
									value={user.code}
									name="code"
									error={formSubmit && formError['code'] && (!formError['code'].valid)}
									onChange={(e) => { this.handleChange(e) }}
								/>
								<input
									required
									id="code"
									label="Code"
									type="text"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Last Name"
									value={user.code}
									name="code"
									error={formSubmit && formError['code'] && (!formError['code'].valid)}
									onChange={(e) => { this.handleChange(e) }}
								/>
								<input
									required
									id="code"
									label="Code"
									type="number"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Mobile Number"
								/>
								<input
									required
									id="code"
									label="Code"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Password"
								/>
								<input
									required
									id="code"
									label="Code"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Confirm Password"
								/>
								<input
									required
									id="code"
									label="Code"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Referral Code"
								/>
							</div>
							<div className="signup-footer-btn">
								<Button htmlType="submit" className='btn-login mg-top' onClick={this.goToSignUpCategory}>CREATE A NEW ACCOUNT</Button>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(Signup);